export function tournamentTitle(name:string,age:string):string {
  // Do not repeat an age already included in the source title.
  return /\d{2}\+/.test(name) ? name : `${name} · ${age}`;
}
